import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY
const SCRIPT_ID = 'recaptcha-script'

let scriptPromise
function loadRecaptcha(lang) {
  if (window.grecaptcha?.render) return Promise.resolve(window.grecaptcha)
  if (!scriptPromise) {
    scriptPromise = new Promise((resolve, reject) => {
      window.__onRecaptchaLoad = () => resolve(window.grecaptcha)
      const s = document.createElement('script')
      s.id = SCRIPT_ID
      s.src = `https://www.google.com/recaptcha/api.js?onload=__onRecaptchaLoad&render=explicit&hl=${lang}`
      s.async = true
      s.defer = true
      s.onerror = () => { scriptPromise = undefined; reject(new Error('recaptcha failed to load')) }
      document.head.appendChild(s)
    })
  }
  return scriptPromise
}

export const captchaEnabled = Boolean(SITE_KEY)

// reCAPTCHA v2 (casilla "No soy un robot"). onToken(token | '') avisa al formulario.
export default function Captcha({ onToken, theme = 'light', className = '' }) {
  const { i18n } = useTranslation()
  const ref = useRef(null)
  const widgetId = useRef(null)

  useEffect(() => {
    if (!SITE_KEY) return undefined
    let cancelled = false
    loadRecaptcha(i18n.language?.startsWith('en') ? 'en' : 'es-419')
      .then((grecaptcha) => {
        if (cancelled || !ref.current || widgetId.current !== null) return
        widgetId.current = grecaptcha.render(ref.current, {
          sitekey: SITE_KEY,
          theme,
          callback: (token) => onToken(token),
          'expired-callback': () => onToken(''),
          'error-callback': () => onToken(''),
        })
      })
      .catch(() => onToken(''))
    return () => { cancelled = true }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!SITE_KEY) return null
  return <div ref={ref} className={className} />
}
